var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallenge3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2917 71.5626L41.0833 59.6876V35.5417L21.2917 23.6667L1.5 35.5417V59.6876L21.2917 71.5626ZM1.5 35.5417L21.2917 47.4168M41.0833 35.5417L21.2917 47.4168M21.2917 47.4168V71.5626",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2292 49.3958L66.0208 37.5208V13.375L46.2292 1.5L26.4375 13.375V37.5208L46.2292 49.3958ZM26.4375 13.375L46.2292 25.25M66.0208 13.375L46.2292 25.25M46.2292 25.25V49.3958",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5212 77.5001L76.3128 65.6251V41.4792L56.5212 29.6042L36.7295 41.4792V65.6251L56.5212 77.5001ZM36.7295 41.4792L56.5212 53.3543M76.3128 41.4792L56.5212 53.3543M56.5212 53.3543V77.5001",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge3);
export default __webpack_public_path__ + "static/media/challenge3.fc25c3ed9cede96718a0d29bfa4b905d.svg";
export { ForwardRef as ReactComponent };